// extracted by mini-css-extract-plugin
module.exports = {"shootingStar":"styles_shootingStar__GAnvZ","shooting":"styles_shooting__5n6ua","tail":"styles_tail__3Lvcb","shining":"styles_shining__8Hoxm"};